module.exports = __webpack_public_path__ + "assets/img/60af072cd0c2efdadc61ff73a70c7ef0.png";